// LOAD USER ACTIVITIES
export const loadUserActivities = (payload) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_ACTIVITIES',
    payload,
});
export const loadUserActivitiesSuccess = (payload) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_ACTIVITIES_SUCCESS',
    payload,
});
export const loadUserActivitiesError = (error) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_ACTIVITIES_ERROR',
    payload: { error },
});
export const resetUserActivities = () => ({
    type: 'OLY_ENGINE_STORE_RESET_USER_ACTIVITIES',
});
// REPLAY USER ACTIVITY
export const replayUserActivity = (payload) => ({
    type: 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY',
    payload,
});
export const replayUserActivitySuccess = (payload) => ({
    type: 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY_SUCCESS',
    payload,
});
export const replayUserActivityError = (error) => ({
    type: 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY_ERROR',
    payload: { error },
});
export const replayUserActivitiesReset = () => ({
    type: 'OLY_ENGINE_STORE_REPLAY_USER_ACTIVITY_RESET',
});
// CREATE USER ACTIVITY
export const createUserActivity = (payload) => ({
    type: 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY',
    payload,
});
export const createUserActivitySuccess = () => ({
    type: 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY_SUCCESS',
});
export const createUserActivityError = (error) => ({
    type: 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY_ERROR',
    payload: { error },
});
export const createUserActivityReset = () => ({
    type: 'OLY_ENGINE_STORE_CREATE_USER_ACTIVITY_RESET',
});
// EDIT USER ACTIVITY
export const editUserActivity = (payload) => ({
    type: 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY',
    payload,
});
export const editUserActivitySuccess = (payload) => ({
    type: 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY_SUCCESS',
    payload,
});
export const editUserActivityError = (error) => ({
    type: 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY_ERROR',
    payload: { error },
});
export const editUserActivityReset = () => ({
    type: 'OLY_ENGINE_STORE_EDIT_USER_ACTIVITY_RESET',
});
// DELETE USER ACTIVITY
export const deleteUserActivity = (payload) => ({
    type: 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY',
    payload,
});
export const deleteUserActivitySuccess = (payload) => ({
    type: 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY_SUCCESS',
    payload,
});
export const deleteUserActivityError = (error) => ({
    type: 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY_ERROR',
    payload: { error },
});
export const deleteUserActivityReset = () => ({
    type: 'OLY_ENGINE_STORE_DELETE_USER_ACTIVITY_RESET',
});
export default {
    loadUserActivities,
    loadUserActivitiesSuccess,
    loadUserActivitiesError,
    resetUserActivities,
    replayUserActivity,
    replayUserActivitySuccess,
    replayUserActivityError,
    replayUserActivitiesReset,
    createUserActivity,
    createUserActivitySuccess,
    createUserActivityError,
    createUserActivityReset,
    editUserActivity,
    editUserActivitySuccess,
    editUserActivityError,
    editUserActivityReset,
    deleteUserActivity,
    deleteUserActivitySuccess,
    deleteUserActivityError,
    deleteUserActivityReset,
};
